import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/mini crackers.png";
import BiscuitImg from "../../../assets/products/crispy bites/Mini-Crackers-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 75,
  },
];

export default function MiniProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Mini Crackers – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Mini Crackers — bite-sized, crisp crackers perfect for snacking. View pack sizes, cartons, and specifications."
        />
        <meta
          name="keywords"
          content="Crispy Mini Crackers, BearBitz Mini Crackers"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/mini-crackers"
        />
        <meta property="og:title" content="Crispy Mini Crackers – BearBitz" />
        <meta
          property="og:description"
          content="Mini crisp crackers by BearBitz, made for premium quality and export readiness."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MINI CRACKERS"
        productImage={BisImg}
        description="Enjoy the crisp and crunchy taste of Mini Cracker Biscuits, baked to perfection in bite-sized goodness. Lightly salted and full of flavor, they’re the perfect snack for tea time, parties, or on-the-go munching."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#6A3E20"
        sectionBgColor="#FFEDAC"
        productBgcolor="#6A3E20"
        tableheadBgcolor="#6A3E20"
        tableBgcolor="#FFF4EE"
        footerBgcolor="#6A3E20"
      />
    </>
  );
}
